import './anchor.styles.css';

export default function Anchor({ id, children }) {
  return (
    <div className='section-anchor-root'>
      <div id={id} className='section-anchor' />
      <div>{children}</div>
    </div>
  );
}
